<template>
	<component
		:is="transitionName || 'div'"
		mode="in"
	>
		<li v-show="currentItem">
			<slot>remove</slot>
		</li>
	</component>
</template>

<script>
import Hammer from 'hammerjs';
import TransitionFade from '@/components/transition-fade';

export default {
	components: {
		TransitionFade,
	},
	inject: {
		provider: Symbol.for( 'carousel' ),
	},
	props: {
		transitionName: {
			type: String,
			default: 'transition-fade',
		},
	},

	computed: {
		currentItem() {
			return this.provider.currentItem === this;
		},
	},

	mounted() {
		const hammer = new Hammer( this.$el );
		hammer.on( 'swipeleft', () => this.setDirection( 'next' ) );
		hammer.on( 'swiperight', () => this.setDirection( 'previous' ) );
	},

	created() {
		this.provider.$emit( 'create:items', this );
	},

	methods: {
		handleEvent() {
			this.provider.$emit( 'set:item', this );
		},

		setDirection( direction ) {
			this.provider.$emit( 'set:direction', direction );
		},
	},
};
</script>
